import { AnimatePresence, motion } from "framer-motion";
import { TimelineItemData } from "../../mock/timeline";
import { Box } from "../Box";
import { ScrollTransform } from "../ScrollTransform";
import { InViewAnimation } from "./InViewAnimation";
import { TimelineGrid } from "./TimelineGrid";
import { TimelineGridItem } from "./TimelineGridItem";
import { TimelineItemImage } from "./TimelineItemImage";
import { TimelineItemText } from "./TimelineItemText";
import { TimelineItemWatermark } from "./TimelineItemWatermark";
import { TimelineItemZoom } from "./TimelineItemZoom";

interface TimelineItemProps {
  timelineItem: TimelineItemData;
  groupActive: boolean;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({
  timelineItem,
  groupActive,
}) => {
  return (
    <Box height={timelineItem.height}>
      <TimelineGrid key={timelineItem.id}>
        <TimelineGridItem gridColumn={timelineItem.gridCol}>
          <Box
            mt={timelineItem.verticalOffset}
            mb={timelineItem.marginBottom}
            padding={timelineItem.padding || null}
            zIndex={timelineItem.layer}
            position="relative"
          >
            <ScrollTransform
              moveFactor={timelineItem.parallaxFactor}
              direction="y"
              debug={timelineItem.debug}
            >
              <InViewAnimation>
                <Box>
                  {timelineItem.type === "text" && (
                    <TimelineItemText data={timelineItem.data} />
                  )}
                  {timelineItem.type === "image" && (
                    <TimelineItemImage data={timelineItem.data} />
                  )}
                </Box>
              </InViewAnimation>

              <AnimatePresence>
                {timelineItem.type === "watermark" && groupActive && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{
                      opacity: 1,
                      transition: { duration: 0.4, delay: 0.6 },
                    }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <TimelineItemWatermark data={timelineItem.data} />
                  </motion.div>
                )}
              </AnimatePresence>
              {timelineItem.type === "zoom" && (
                <TimelineItemZoom data={timelineItem.data} />
              )}
            </ScrollTransform>
          </Box>
        </TimelineGridItem>
      </TimelineGrid>
    </Box>
  );
};
